var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.countries,"autocomplete":"","label":_vm.label,"disabled":(_vm.defaultCountry) ? true : false,"multiple":(_vm.multiple) ? true : false},model:{value:(_vm.countrySelected),callback:function ($$v) {_vm.countrySelected=$$v},expression:"countrySelected"}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd4c3d14","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/converter/SelectCurrency.vue
// module id = null
// module chunks = 